module.exports = "/packs/mastercard-18e366b242b071f6c7d60e3469802d25.png";